import React from 'react';
import s from './Loading.module.sass';
 
const LoadingScreen = () => (
  <div className={s['loading-screen']}>
    <p>Laddar...</p>
  </div>
);
 
export default LoadingScreen;
